<script setup>

import StandardSlider from '../components/StandardSlider.vue'
import NavButton from '../components/NavButton.vue'
import {store} from '@/store'

const props = defineProps({
  title: String,
    } )
</script>

<template>
    <div class="page__custom-standard">
        <h2>{{ props.title }}</h2>
        <div class="row">
            <div class="col-md-4 body-text">
                <slot></slot>
            </div>
            <div class="col-md-8">
                <div class="custom-standards-list">
                    <StandardSlider 
                        v-for="(standard, index) in store.formData.standards"
                        :key="index"
                        :standard="standard"
                        :couple="store.formData.user.isCouple"
                        />
                </div>
                <div class="callout-box slider">
                    <StandardSlider 
                        :standard="store.formData.standardTotal"
                        :couple="store.formData.user.isCouple"
                        :isTotal="true"
                        />
                </div>
                <div class="nav-bar">
                    <NavButton dir="<" v-on:click="store.formState.page = 'home'">Retirement Living Standards Modeller</NavButton>
                    <NavButton dir=">" v-on:click="store.formState.modal = 'sra'">Add my retirement savings</NavButton>
                </div>
            </div>
        </div>
    </div>
</template>
